import Vue from 'vue'
import Vuex from 'vuex'
import location from './modules/location'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		location
	},
  
	// Global state (if needed)
	state: {
		// Add any global state here
	},
  
	// Global mutations (if needed)
	mutations: {
		// Add any global mutations here
	},
  
	// Global actions (if needed)
	actions: {
		// Add any global actions here
	},
  
	// Global getters (if needed)
	getters: {
		// Add any global getters here
	}
})